import { render } from "./HotkeyDoc.vue?vue&type=template&id=47d0351b&scoped=true"
import script from "./HotkeyDoc.vue?vue&type=script&lang=js"
export * from "./HotkeyDoc.vue?vue&type=script&lang=js"

import "./HotkeyDoc.vue?vue&type=style&index=0&id=47d0351b&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d0351b"]])

export default __exports__